import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import * as moment from "moment-timezone";
import {ConversorsService} from "./conversors.service";
import {ImportCsvEntityType} from "../model/import-csv/csv-measurement-data";

@Injectable({
  providedIn: 'root'
})
export class MeasuresService {

  private readonly measuresURL: string;
  private convert = this.conversorsService.convert;

  constructor(private http: HttpClient,
              private conversorsService: ConversorsService) {
    this.measuresURL = "/catalog/measures";
  }

  public searchDeviceMeasures(tenantUuid: string, deviceUuid: string, sensorUuid: string, from: number, until: number) {
    let url = `${this.measuresURL}/${tenantUuid}/device/${deviceUuid}/${sensorUuid}/${from}/${until}`;
    return this.http.get<any>(url);
  }

  public searchAssetMeasures(tenantUuid: string, deviceUuid: string, sensorUuid: string, from: number, until: number) {
    let url = `${this.measuresURL}/${tenantUuid}/asset/${deviceUuid}/${sensorUuid}/${from}/${until}`;
    return this.http.get<any>(url);
  }

  public searchKpiMeasures(tenantUuid: string, kpiUuid: string, from: number, until: number) {
    let url = `${this.measuresURL}/${tenantUuid}/kpis/${kpiUuid}/${from}/${until}`;
    return this.http.get<any>(url);
  }

  public buildSensorMeasures(rawData: any[], origin?: string, target?: string): any[] {
    let sensorMeasures = [];
    for(let measure of rawData) {
      let value = measure.value;
      if(value === 'true') {
        value = 1;
      } else if(value === 'false') {
        value = 0;
      } else {
        if (origin != null) value = this.convertValue(parseFloat(measure.value), origin, target);
        else value = parseFloat(measure.value);
      }
      sensorMeasures.push([moment(measure.timestamp).utc().valueOf(), value]);
    }
    return sensorMeasures;
  }

  public convertValue(value: number, origin: string, target: string): number {
    const units = this.convert().possibilities();
    let originUnit;
    let targetUnit;
    units.map(unit => {
      if (unit === origin) originUnit = unit;
      if (unit === target) targetUnit = unit;
    })
    if (originUnit === undefined || targetUnit === undefined) {
      return value;
    }
    return this.convert(value).from(originUnit).to(targetUnit);
  }

  public importMeasurementsFromCsv(files: File[], uuid: string, entityType: ImportCsvEntityType) {
    const url = `${this.measuresURL}/import-csv`;

    const formData = new FormData();
    files.forEach(file => formData.append("files", file));
    formData.append('uuid', uuid);
    formData.append('entityType', entityType.toString());

    return this.http.post<void>(url, formData);
  }

}
